@mixin arrow-right($size){
  .arrow-right {
    border-top: $size solid transparent;
    border-bottom: $size solid transparent;
    border-left: $size solid white;
  }
}

@mixin arrow-left($size){
  .arrow-left {
    border-top: $size solid transparent;
    border-bottom: $size solid transparent;
    border-right: $size solid white;
  }
}

@mixin button-style {
  float: left;
  cursor: pointer;
  button {
    box-shadow: none !important;
    outline: none !important;
    border:none;
    padding-top: 14px;
    padding-bottom: 14px;
    @media (min-width: 768px) and (max-width: 1100px){
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
}

.left-col {
  @include button-style;
  @include arrow-left(8px);
  button{
    border-radius: 6px 0 0 6px;
  }
}

.right-col {
  @include button-style;
  @include arrow-right(8px);
  button{
    border-radius: 0 6px 6px 0;
  }
}

.center-col {
  float: left;
  border-right: 1px solid #000000;
  border-left: 1px solid #000000;
  font-weight: lighter;
  font-size: 22px;
  padding-right: 15px;
  input{
    border: none;
    text-align: right;
    outline: none;
    padding-top: 8px;
    padding-bottom: 6px;
    padding-left:0;
    padding-right: 0;
  }
}

@media (min-width: 765px) and (max-width: 1100px){
  .left-col{
    @include arrow-left(6px);
  }
  .right-col{
    @include arrow-right(6px);
  }

  .center-col{
    font-size: 16px !important;
    padding-right: 4px !important;
    input{
      font-size: 14px;
    }
  }
}

@media (min-width: 520px) and (max-width: 760px){
  .center-col{
    padding-left: 10px !important;
    padding-right: 20px !important;
  }
}

.inc-dec {
  box-shadow: 0 5px 2px -1px black;
  border-radius: 8px;
  @media (max-width: 767px) {
    .center-col{
      input{
        width:85px;
      }
    }
  }
}

@media (min-width: 1400px){
  .inc-dec {
    .left-col {
      button {
        padding: 5px 10px;
      }
    }
    .center-col {
      font-size: 15px !important;
      input {
        padding-top: 4px;
        padding-bottom: 0;
      }
    }
    .right-col {
      button {
        padding: 5px 10px;
      }
    }
  }
}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-prod-baristadj-server/src/app/components/incdec/incdec.scss